import { getDeliveryDetail } from '../libs/deliveryDetailAdapter';
import { useQuery } from '@tanstack/react-query';
import { basketAPI } from '../api/basketAPI';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { setDeliveryTime } from '../../../store/slices/delivery';
// import { selectTotalPrice } from '@/store/selectors/basket';

export const useGetDeliveryDetail = (totalPrice: number, branch?: number) => {
  const address_id = localStorage.getItem('address') ?? undefined;
  const dispatch = useDispatch();
  // const totalPrice = useSelector(selectTotalPrice);

  const initData = { deliveryDetail: getDeliveryDetail() };

  const { data = initData, isLoading } = useQuery({
    queryKey: ['delivery-detail', branch, address_id, totalPrice],
    queryFn: async () =>
      await basketAPI.getDeliveryDetail(branch!, totalPrice, address_id),
    select: data => ({
      deliveryDetail: getDeliveryDetail(data.data),
    }),
    enabled: !!branch,
  });

  useEffect(() => {
    if (data?.deliveryDetail) {
      dispatch(setDeliveryTime(data.deliveryDetail));
    }
  }, [data?.deliveryDetail, dispatch, totalPrice]);

  return {
    deliveryDetail: data.deliveryDetail,
    isLoading,
  };
};
